import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { H1 } from '../../atoms';

const CenteredRow = styled(Row)`
  height: 100%;
  align-items: center;
`;

const CenteredCol = styled(Col)`
  text-align: center;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const FullHeightGrid = styled(Grid)`
  padding: 28px;
  box-sizing: border-box;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: var(--elevation-low);
`;

const PageTitle = styled(H1)`
  margin-bottom: 20px;
`;

const CenteredLayout = ({ children = null, title = null, className = null }) => (
  <FullHeightGrid as='main' fluid className={className}>
    <CenteredRow>
      <CenteredCol xs={12} sm={8} md={6} lg={4} smOffset={2} mdOffset={3} lgOffset={4}>
        <ContentWrapper>
          {title && <PageTitle>{title}</PageTitle>}
          {children}
        </ContentWrapper>
      </CenteredCol>
    </CenteredRow>
  </FullHeightGrid>
);

CenteredLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  className: PropTypes.string
};

export { CenteredLayout };
